import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Button,
} from '@mui/material';
import BookmarkAddedIcon from '@mui/icons-material/BookmarkAdded';

export default function FeatureAnnouncementModal({ open, handleClose, onView }) {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: '16px', padding: '.5rem' } }}
    >
      <DialogContent sx={{ textAlign: 'center', pt: 4 }}>
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: '50%',
            backgroundColor: 'primary.main',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 2,
          }}
        >
          <BookmarkAddedIcon sx={{ fontSize: 40, color: 'white' }} />
        </Box>
        <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', mb: 1 }}>
          New: Save your cover letters
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Tap the bookmark on any cover letter to save and name it. Find all
          your saved letters anytime under <strong>My Letters</strong> in the
          top menu — search, rename, and reuse them whenever you need.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ flexDirection: 'column', gap: 1, px: 3, pb: 3 }}>
        <Button
          onClick={onView}
          variant="contained"
          color="primary"
          fullWidth
          size="large"
          sx={{
            fontWeight: 'bold',
            '&:hover': { backgroundColor: 'blue', transform: 'scale(1.03)' },
          }}
        >
          View My Letters
        </Button>
        <Button onClick={handleClose} color="inherit" fullWidth>
          Got it
        </Button>
      </DialogActions>
    </Dialog>
  );
}
